import styled from 'styled-components';

export const Text = styled.div`
  color: var(--aqua-500);
  font-size: 14px;
  letter-spacing: 0.571px;
  line-height: 18px;
  text-align: right;
`;
